import { render, staticRenderFns } from "./VerticalNavMenuRight.vue?vue&type=template&id=ff9a027a&"
import script from "./VerticalNavMenuRight.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuRight.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports